import { Component, Input, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ModalController } from "@ionic/angular";
import { LoveItAlertService } from "../../services/love-it-alert.service";
import { isMobile } from "../../global-functions/global-functions";

@Component({
  selector: "app-edit-field-modal",
  templateUrl: "./edit-content-modal.component.html",
  styleUrls: ["./edit-content-modal.component.scss"],
  standalone: false,
})
export class EditContentModalComponent implements OnInit {
  @Input({ required: true }) title: string;
  @Input({ required: true }) value: string;
  @Input({ required: true }) saveFunction: (value: string) => Promise<string>;

  formControl = new FormControl();
  isSaving: boolean = false;

  constructor(
    private modalController: ModalController,
    private loveItAlertService: LoveItAlertService,
  ) {}

  ngOnInit() {
    this.formControl.setValue(this.value ?? "");
    this.formControl.markAsPristine();
  }

  cancelModal() {
    this.modalController.dismiss(null, "cancel");
  }

  async saveButton() {
    try {
      this.isSaving = true;
      const savedValue: string = await this.saveFunction(this.formControl.value);
      await this.modalController.dismiss(savedValue, "confirm");
      this.isSaving = false;
    } catch (error) {
      this.isSaving = false;
    }
  }

  async openDiscardAlert() {
    if (this.formControl.pristine) {
      this.cancelModal();
      return;
    }
    const alert = await this.loveItAlertService.create({
      cssClass: "loeschen",
      header: "Verwerfen",
      message: "Ungespeicherte Änderungen wirklich verwerfen?",
      buttons: [
        {
          text: "Abbrechen",
          role: "cancel",
          cssClass: "color-primary",
        },
        {
          cssClass: "color-danger",
          text: "Verwerfen",
          handler: () => {
            this.cancelModal();
          },
        },
      ],
    });

    await alert.present();
  }

  protected readonly Object = Object;
  protected readonly isMobile = isMobile;
}
